import React, { useState } from "react";
import DeveloperPlan from "./components/DeveloperPlan";
import { useUsersContext } from "../../../../context/usersContext";
import PricingPlanCard from "./components/PricingPlanCard";
import PricingFooter from "./components/PricingFooter";
import { useUserInfo } from "../../../../context/user";
import CancelModal from "../Balance/component/CancelModal";
import CancelConfirmModal from "../Balance/component/CancelConfirmModal";

const Pricing = ({ limit, pricingHeading, setActiveTab }) => {
  const { products, agency } = useUsersContext();
  const [planType, setPlanType] = useState("monthly");
  const userActiveLocation = useUserInfo()[4]
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);


  return (
    // <>
    //   {userActiveLocation.business_type === 'Developer' ? (
    //     <DeveloperPlan setShowDeveloperPlan={setShowDeveloperPlan} setActiveTab={setActiveTab} />
    //   ) : (
    <>
      {/* {developerPlans?.length > 0 && <p
            onClick={() => setShowDeveloperPlan(true)}
            className="flex float-end pb-4 underline font-medium cursor-pointer"
          >
            Are you a Developer?
          </p>} */}

      <div className="w-full h-full flex flex-col items-center justify-center">
        {userActiveLocation?.account_type === 'Developer' ? (<> <h1 className="text-[30px] ">Developer Plan</h1>
          <p className="text-lg mt-[18px] text-center max-w-[800px]">
            Choose the perfect plan for your needs
          </p>

        </>) : pricingHeading !== "" ? (
          <div className="max-w-[460px]">
            <h2 className="text-3xl font-semibold text-center">
              {pricingHeading}
            </h2>
          </div>
        ) : (
          <>
            <h1 className="text-[30px]">
              {agency?.pricing_page_headline
                ? agency?.pricing_page_headline
                : "Pricing Plans"}
            </h1>
            <p className="text-lg mt-[18px]">
              Choose the perfect plan for your needs
            </p>
          </>
        )}

        <div className="px-5 text-sm font-medium py-[10px] flex items-center w-fit border mt-10 rounded-full">
          <span
            onClick={() => setPlanType("monthly")}
            className={`w-[111px] h-[44px] flex justify-center items-center cursor-pointer rounded-full ${planType === "monthly"
              ? "bg-black text-white"
              : "hover:bg-black hover:text-white"
              }`}
          >
            Monthly
          </span>
          <span
            onClick={() => setPlanType("yearly")}
            className={`h-[44px] flex justify-center px-5 items-center ml-3 cursor-pointer rounded-full ${planType === "yearly"
              ? "bg-black text-white"
              : "hover:bg-black hover:text-white"
              }`}
          >
            Yearly - Save up to 17.5%
          </span>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 md:grid-cols-2 gap-3 my-5 mt-10 rounded-lg">
        {products
          ?.filter((product) => { if (userActiveLocation.account_type === 'Developer') { return product?.developer_plan === true } else { return product?.isenable_account === true } })
          ?.sort((a, b) => {
            const priceA =
              planType === "monthly"
                ? a.monthly_amount || 0
                : a.yearly_amount || 0;
            const priceB =
              planType === "monthly"
                ? b.monthly_amount || 0
                : b.yearly_amount || 0;
            return priceA - priceB;
          })
          ?.map((product) => (
            <PricingPlanCard
              data={product}
              key={product?._id}
              planType={planType}
              setActiveTab={setActiveTab}
              agency={agency}
              setOpenCancelModal={setOpenCancelModal}
            />
          ))}
      </div>
      <div className="text-center mt-10">
        <p className="text-xl font-medium text-black">
          {agency?.pricing_page_message || ""}
        </p>
      </div>
      <PricingFooter />

      {openCancelModal && (
        <CancelModal
          isOpen={openCancelModal}
          onClose={() => {
            setOpenCancelModal(false);
          }}
          setOpenConfirmModal={setOpenConfirmModal}
        />
      )}
      {openConfirmModal && (
        <CancelConfirmModal
          isOpen={openConfirmModal}
          onClose={() => setOpenConfirmModal(false)}
        />
      )}
    </>
  );
};

export default Pricing;
